export const apiVersion = process.env.NEXT_PUBLIC_SANITY_API_VERSION || "2026-03-04"

export const dataset = assertValue(
    process.env.NEXT_PUBLIC_SANITY_DATASET,
    "Missing environment variable: NEXT_PUBLIC_SANITY_DATASET"
)

export const projectId = assertValue(
    process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
    "Missing environment variable: NEXT_PUBLIC_SANITY_PROJECT_ID"
)

export const useCdn = false

export const contentServiceBaseUrl = assertValue(
    process.env.NEXT_PUBLIC_CONTENT_SERVICE_API_BASE_URL,
    "Missing env: NEXT_PUBLIC_CONTENT_SERVICE_API_BASE_URL"
)

function assertValue<T>(v: T | undefined, errorMessage: string): T {
    if (v === undefined) {
        throw new Error(errorMessage)
    }

    return v
}

export const clientConfig = {
    apiVersion,
    dataset,
    projectId,
    useCdn
}
